export const Roles = {
    'All roles': 'All roles',
    Admin: 'Admin',
    Manager: 'Manager',
    User: 'User',
    Owner: 'Owner',
    Agent: 'Agent'
};
